exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "legend {\n    font-weight: bold;\n}\n.select-mode label {\n    padding-left: 2em;\n}\n@media (min-width: 768px) {\n    .mode-panel label {\n        padding-left: 2em;\n    }\n}\n.mode-panel .form-group {\n    margin-bottom: 0.5em;\n}\n.has-danger .form-control-feedback {\n    font-size: 0.7em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/admin/sensor-parameters/sensor-parameters.component.css
// module id = ../../../../../src/app/admin/sensor-parameters/sensor-parameters.component.css
// module chunks = main